var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pb-6"},[_c('v-row',{staticClass:"flex-column primary",staticStyle:{"padding-bottom":"200px"},attrs:{"justify":"center","align":"center"}},[_c('nuxt',{staticClass:"px-6"})],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Expert Retainer")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }